import { ReactElement, useState } from 'react';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { Typography } from 'common/components/antd/Typography/Typography';
import {
  SContainer,
} from './TruncatedTextCell.style';
import { TruncateText } from '../Utilities/TruncateText';

type TruncatedTextCellProps = {
  children: string;
  rowIndex: number;
  hoveredRowIndex: number | null | any;
};

export const TruncatedTextCell = (
  { children: text, rowIndex, hoveredRowIndex }: TruncatedTextCellProps
): ReactElement => {
  const [truncated, setTruncated] = useState<boolean>(true);
  const isHovered = hoveredRowIndex === rowIndex;
  const { t } = useTranslation();

  return (
    <SContainer>
      <TruncateText length={truncated ? 12 : text.length}>{text}</TruncateText>

      <Space
        style={{
          marginLeft: '8px',
        }}
      >
        <Typography.Text
          style={{
            visibility: isHovered ? 'visible' : 'hidden',
          }}
        >
          {truncated ? (
            <EyeInvisibleOutlined
              className="ant-typography-copy"
              onClick={(): void => {
                setTruncated(false);
              }}
            />
          ) : (
            <EyeOutlined
              className="ant-typography-copy"
              onClick={(): void => {
                setTruncated(true);
              }}
            />
          )}
        </Typography.Text>

        <Typography.Text
          rootClassName="custom-ant-typography"
          copyable={{
            text,
            tooltips: [t('common.copy'), t('common.copied')]
          }}
        />
      </Space>
    </SContainer>
  );
};
